import { Accept } from 'react-dropzone';

export const getMimeTypes = (type: string) => {
  switch (type) {
    case 'application/pdf':
      return 'pdf';
    case 'application/zip':
      return 'zip';
    case 'application/gzip':
      return 'gzip';
    case 'application/xhtml+xml':
      return 'xhtml';
    case 'application/xml':
      return 'xml';
    case 'application/json':
      return 'json';
    case 'image/png':
      return 'png';
    case 'image/jpeg':
      return 'jpeg';
    case 'image/jpg':
      return 'jpg';
    case 'image/gif':
      return 'gif';
    case 'image/svg+xml':
      return 'svg';
    case 'application/vnd.ms-powerpoint':
      return 'ppt';
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return 'pptx';
    case 'application/vnd.ms-excel':
      return 'xls';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'xlsx';
    case 'text/csv':
      return 'csv';
    default:
      return '';
  }
};

export const acceptFileTypes: Accept = {
  'application/msword': ['.docx', '.doc'],
  'application/pdf': ['.pdf'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  '	application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
};

export const acceptImageTypes = () => {
  return 'image/png, image/jpg, image/jpeg';
};

export const getFileTypeCard = (item: any) => {
  const isArquive = Object.hasOwn(item, 'original_name');

  if (!isArquive) {
    return 'folder';
  }

  const isFile = item.size !== null;

  if (!isFile) {
    return 'link';
  }

  return 'file';
};

export const maxUploadSize = 524_288_000; // 500MB
